import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import FormInputField from "../FormTextInput/FormInputField";
import { languageSelector } from "../../../features/language/languageSlice";

const requiredFieldMsg = "RequiredFieldErrMsg";

function NotesForm({ addNote, t, quotesNotes }) {
  const lang = useSelector(languageSelector);

  const {
    register,
    control,
    reset,
    getValues,
    setValue,
    trigger,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(
      Yup.object({
        description: Yup.string().required(requiredFieldMsg),
      }),
    ),
    defaultValues: {
      description: "",
    },
    mode: "onBlur",
  });
  const values = getValues();
  const handleChange = (e) => {
    e.persist();
    setValue(e.target.name, e.target.value);
    trigger(e.target.name);
  };
  const dropdownChange = (e, name) => {
    setValue(name, e);
    trigger(name);
  };
  return (
    <div className="bg-white px-[43px] rounded">
      {!quotesNotes && (
        <h2 className="font-[700] font-montserrat leading-[26.82px] pt-[32px] text-[22px]">
          {t("notes")}
        </h2>
      )}
      <form
        // onSubmit={handleSubmit(addNote)}
        className="font-open-sans pt-[24px]"
      >
        <div>
          <FormInputField
            fieldName={`description`}
            type="textarea"
            id="description"
            // register={{
            //   ...register(`description`),
            // }}
            register={register}
            // errorMessage={errors?.description && t("RequiredFieldErrMsg")}
            handleChange={handleChange}
            value={values.description}
            placeholder={t("NotesPlaceholder")}
            mainClassnames="border-[#A09F9F] h-[120px] mt-[16px] pt-[12px] px-[16px] resize-none w-[677px]"
            isMultiLineText={true}
          />
        </div>
        <div className="text-secondary-red font-semibold">
          {errors?.description && t("RequiredFieldErrMsg")}
        </div>
        <div className="flex gap-[16px] justify-end pb-[32px] pt-[32px]">
          <button
            onClick={() => reset()}
            type="reset"
            className="focus-visible:bg-[#ECECEC] font-[600] h-[40px] hover:bg-[#ECECEC] leading-[21.79px] rounded-sm text-[#E2211C] text-[16px] text-center w-[120px]"
          >
            {t("cancel")}
          </button>
          <button
            className="btn__secondary font-[600] h-[40px] leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-[120px]"
            onClick={() => {
              handleSubmit(addNote)();
              reset();
            }}
            type="button"
          >
            {t("save")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default React.memo(NotesForm);
